/**
 * SpaContextServiceStandalone — no-op. Standalone has no host voice/Pi agent to
 * SEE the screen, so publishing an on-screen snapshot has nowhere to go.
 */
import type { SpaContextService } from '../types';

export class SpaContextServiceStandalone implements SpaContextService {
  publish(): void {
    /* no host to receive the snapshot */
  }

  clear(): void {
    /* no-op */
  }
}
